(function () {
  function init(root) {
    if (!root || root.dataset.bn3Ready === 'true') return;
    root.dataset.bn3Ready = 'true';

    var reveals = root.querySelectorAll('[data-bn3-reveal]');
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) {
      reveals.forEach(function (item) { item.classList.add('is-in'); });
    } else {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      reveals.forEach(function (item) { observer.observe(item); });
    }

    root.querySelectorAll('details').forEach(function (detail) {
      detail.addEventListener('toggle', function () {
        if (!detail.open) return;
        var group = detail.closest('[data-bn3-accordion]');
        if (!group) return;
        group.querySelectorAll('details[open]').forEach(function (other) {
          if (other !== detail) other.open = false;
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-bn3]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
